import {Component, Input, OnInit} from '@angular/core';
import {WelfareResultService} from '../../service/welfare-result.service';
import {HomeAsset} from '../../class/home-asset';

@Component({
    selector: 'app-asset-home',
    templateUrl: './asset-home.component.html',
    styleUrls: ['./asset-home.component.css']
})
export class AssetHomeComponent implements OnInit {

    @Input()
    homeAsset: HomeAsset;

    constructor(private welfareService: WelfareResultService) {
    }

    ngOnInit() {
    }

    calTotalVal() {
        this.homeAsset.expetedValue = this.homeAsset.mq * this.homeAsset.mqValue;
    }

    deleteHome() {
        this.welfareService.removeAsset(this.homeAsset);
    }
}
